import { unwrapResult } from '@reduxjs/toolkit';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Text } from '@rsos/components/capstone/base';
import { fetchAgencies } from '@rsos/reduxDataStore/src/features/peerAgencies/peerAgenciesSlice';
import InviteAgencyModal from '../InviteAgencyModal';
import LinksToRow from './LinksToRow';
import { TableContainer, TableHeader } from './LinksToTable.styles';

const LinksToTable = () => {
  const dispatch = useDispatch();

  const { sinatra } = useSelector(state => state);

  const org = sinatra.user.currentOrg.name;

  const [isFetching, setIsFetching] = useState(false);

  const [fetchError, setFetchError] = useState('');

  const [agencies, setAgencies] = useState([]);

  const [showNoAgenciesAvailable, setShowNoAgenciesAvailable] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchAvailableAgencies = () => {
    setIsFetching(true);

    setFetchError('');

    dispatch(fetchAgencies({ org }))
      .then(unwrapResult)
      .then(response => {
        const { authorities, total_records } = response;

        if (authorities.length && total_records > 0) {
          const sortedAuthorities = authorities.sort((a, b) =>
            a.display_name.localeCompare(b.display_name),
          );

          setShowNoAgenciesAvailable(false);

          setAgencies(sortedAuthorities);
        } else {
          setShowNoAgenciesAvailable(true);

          setAgencies([]);
        }
      })
      .catch(error => {
        setFetchError(error);
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  const handleFetchRetry = () => {
    fetchAvailableAgencies();
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
    fetchAvailableAgencies();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Box my="25px">
        <Text
          color="primaryText"
          data-name="links-to-table-description"
          mb="10px"
          size="small"
        >
          Invite agencies to be your peer agency. Your agency can send events to
          the agencies that have accepted your invitation.
        </Text>
        <TableContainer>
          <Box mb="3px" horizontal={true} align="center">
            <Box width="50%">
              <TableHeader>Name</TableHeader>
            </Box>
            <Box width="25%">
              <TableHeader>Status</TableHeader>
            </Box>
            <Box width="25%" align="flex-end">
              <Button
                btnType="primary"
                dataName="invite-agency-button"
                noMargin
                onClick={() => handleOpenModal()}
                size="small"
                style={{ width: '100px' }}
              >
                Invite Agency
              </Button>
            </Box>
          </Box>
          <LinksToRow />
        </TableContainer>
      </Box>
      <InviteAgencyModal
        agencies={agencies}
        fetchError={fetchError}
        isFetching={isFetching}
        isOpened={isModalOpen}
        onClose={handleCloseModal}
        onHandleFetchRetry={handleFetchRetry}
        showNoAgenciesAvailable={showNoAgenciesAvailable}
      />
    </>
  );
};

export default LinksToTable;
